<template>
  <div class="orderPay" >
    <!-- <topTitle title="订单支付"></topTitle> -->
    <div class="topTitle isFixed">
      <div class="img" @click="fanhui">
        <img src="../../assets/localImage/return.png" alt />
      </div>
      <h2>订单支付</h2>
    </div>
     <div class="payMoney" >
		 <p>应付金额</p>
		 <h4> <span>¥</span>{{totalPrice}}</h4>
	 </div>
	 <div class="choosePay" >
	 <div class="payTitle">选择支付方式：</div>
	 <div class="list mt-0">
	   <van-radio-group v-model="radio">
	     <div class="item">
	       <div class="wx">
	         <img src="../../assets/localImage/weixinzhifu.png" alt />
	         微信支付
	       </div>
	       <van-radio name="1"></van-radio>
	     </div>
	    <!-- <div class="item">
	       <div class="zfb">
	         <img src="../../assets/localImage/zhifubao.png" alt />
	         支付宝支付
	       </div>
	       <van-radio name="2"></van-radio>
	     </div> -->
	   </van-radio-group>
	 </div>
	 </div>
	<div class="payBtn" >
	  <button @click="payResult()" >支付¥{{totalPrice}}</button>
	</div>   
  </div>
</template>

<script>
// import topTitle from "../../components/topTitle.vue";
export default {
  name: "orderPay",
  data() {
    return {
         radio:1,
     orderPayData:this.$route.query.payData,
     totalPrice : '',
     tradeSn : '',
     iscart : localStorage.getItem("isCart")
    };
  },
  components: {
    // topTitle,
  },
  mounted(){
    console.log(this.$route.query.payData)
     console.log(this.$route.query.payData.price_detail.total_price)
      console.log(this.$route.query.payData.trade_sn)
    if(this.$route.query.type == 1){
      this.totalPrice = this.$route.query.order_price;
      this.tradeSn = this.$route.query.sn;
    }else{
      this.totalPrice = this.$route.query.payData.price_detail.total_price;
      this.tradeSn = this.$route.query.payData.trade_sn;
    }
  },
  methods: {
    fanhui() {
      if(this.iscart == 1){
         this.$router.push({ path: "/shoppingCart"});
      }else{
        if(this.$route.query.type == 1){
           this.$router.go(-1)
        }else{
           this.$router.push({ 
            path: "/goodsDetail",
            query : {
            goods_id : this.orderPayData.order_list[0].sku_list[0].goods_id
            }
           });
        }
       
      }
     
    },
	  payResult(){
      let that = this;
		 let param = {
			  client_type : 'WAP',
			  pay_mode : 'normal',
        payment_plugin_id : 'weixinPayPlugin',
		  }
		 this.getRequest(`order/pay/app/order/${this.tradeSn}`, param).then(dres => {
     console.log(dres,dres.data,dres.data.data);
        function onBridgeReady(){
          WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
         "appId":dres.data.data.appId,     //公众号名称，由商户传入     
         "timeStamp":dres.data.data.timeStamp,         //时间戳，自1970年以来的秒数     
         "nonceStr":dres.data.data.nonceStr, //随机串     
         "package":dres.data.data.package,     
         "signType":"MD5",         //微信签名方式：     
         "paySign":dres.data.data.paySign,  //微信签名 
          // success: function (res) {
          //   if(res.err_msg == "get_brand_wcpay_request:ok" ){
          //      that.$router.push({
          //     path:'/SuccessfulPayment',
          //     // query:{
          //     //  ztradeSn : that.tradeSn 
          //     // }
          //   });	 // 支付成功后的回调函数
          //   localStorage.setItem("ztradeSn", that.tradeSn );
          //   alert('aaaa')
          //   Toast.success('支付成功');
          // }else{
          //   Toast.fail('支付失败');
          // }
           
          //   }
          },
          function(res){
          if(res.err_msg == "get_brand_wcpay_request:ok" ){
            that.$router.push({
                path:'/SuccessfulPayment',
                });
              localStorage.setItem("ztradeSn", that.tradeSn );
            Toast.success('支付成功');
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }else{
            Toast.fail('支付失败');
            alert('aaaa')
          }
         } 
          )
    }
    if (typeof WeixinJSBridge == "undefined"){
      if( document.addEventListener ){
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
      }else if (document.attachEvent){
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
      }
    }else{
      onBridgeReady();
    }



    //   onBridgeReady()
    //  function onBridgeReady(){
    //    eval(res.data.data) 
    //   // res.data.data.substring(1,str.length-1)
    //   // var val = new Function(res.data.data);
		// 	//  val()
    //   }
     
		 });
		  // this.$router.push('./SuccessfulPayment')
	  }
  }
};
</script>
<style scoped lang='less'>
 .orderPay{
     .topTitle {
    padding: 0 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 89px;

    .img {
      width: 20px;
      height: 36px;
    }
    h2 {
      font-weight: 500;
      font-size: 36px;
      margin: 0 auto;
    }
    button {
      font-size: 26px;
      font-weight: 400;
      background-color: #ffffff;
      color: #000000;
    }
  }
	 .payMoney{
		 text-align: center;
		 background-color: #fff;
		 padding: 40px 0;
		 margin-bottom: 20px;
		 p{
		   font-size:28px;
		   color: #666666;
		   margin: 20px 0;
		   text-align: center;
		 }
		 h4{
			 color: #000000;
       font-size: 62px;
       text-align: center;
			 span{
				 font-size: 30px;
			 }
		 }
	 }
  .choosePay{
	  background-color: #fff;
   .payTitle {
     height: 74px;
     line-height: 74px;
     font-size: 26px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: rgba(158, 158, 158, 1);
     padding-left: 32px;
   }
   .list {
     background: #ffffff;
     margin-top: 20px;
     .item {
       width: 100%;
       height: 96px;
       padding: 0 33px;
       display: flex;
       justify-content: space-between;
       align-items: center;
       border-bottom: 1px solid #f1f1f1;
       .wx {
         img {
           width: 42px;
           height: 37px;
           margin-right: 15px;
           float: left;
         }
       }
       .zfb {
         img {
           width: 38px;
           height: 38px;
           margin-right: 15px;
           float: left;
         }
       }
   
       /deep/.van-radio__icon--checked .van-icon {
         background: linear-gradient(to right, #fc4d1d, #cf1104);
         border-color: transparent;
       }
       div {
         font-size: 30px;
         font-family: PingFangSC-Regular, PingFang SC;
         font-weight: 400;
         color: rgba(51, 51, 51, 1);
         .color-js {
           color: #ff1919;
         }
       }
       .color-js {
         color: #ff1919;
       }
     }
   }
   }
   .payBtn{
       padding:12px 78px;
       position: fixed;
       bottom: 40px;
       width: 100%;
     button{
         background: linear-gradient(to right,#F24C0B,#F2170C);
         width: 100%;
         height: 88px;
         line-height:88px;
         letter-spacing:2px;
         font-size:36px;
         color: #fff;
         border-radius: 40px;
       }
   }
 }
</style>


